import { useState, useEffect, useMemo } from "react";
import { globalConstants } from "../../constants";
import { getAllStoreIds } from "../utility";

const useCompanyStoreFilter = (
  currentStoreCompany,
  currentStore,
  stores,
  defaultToCurrentStore = false
) => {
  const companyStores = useMemo(
    () =>
      stores?.filter((store) => store.companyId === currentStoreCompany?.id) ||
      [],
    [stores, currentStoreCompany?.id]
  );
  const [selectedStore, setSelectedStore] = useState({
    label: globalConstants.ALL_STORES,
    value: getAllStoreIds(companyStores),
  });
  useEffect(() => {
    if (!defaultToCurrentStore && companyStores.length) {
      setSelectedStore({
        label: globalConstants.ALL_STORES,
        value: getAllStoreIds(companyStores),
      });
    }
  }, [companyStores, defaultToCurrentStore]);

  const selectedStoreId = currentStoreCompany?.isDummyCompany
    ? currentStore?.id
    : selectedStore?.value;

  useEffect(() => {
    if (defaultToCurrentStore && currentStore?.id) {
      setSelectedStore({
        label: currentStore.storeName,
        value: currentStore.id,
      });
    }
  }, [currentStore.id, currentStore.storeName, defaultToCurrentStore]);

  return {
    selectedStore,
    setSelectedStore,
    companyStores,
    selectedStoreId,
  };
};
export default useCompanyStoreFilter;
export { useCompanyStoreFilter };
